<template>
  <div>
    <svg class='arrow'
         :style='style'
         version='1.1'
         xmlns='http://www.w3.org/2000/svg'
         x='0px'
         y='0px'
         viewBox='0 0 45 35'>
     <path class="cls-5" d="M682.56,406.25a22,22,0,1,0-22-22,22,22,0,0,0,22,22" transform="translate(-660.56 -362.25)"/>
     <path class="cls-3" d="M682.07,392.59,674,384.48l8.11-8.12-2.12-2.12-8.12,8.11v4.25l8.13,8.12Z" transform="translate(-660.56 -362.25)"/>
     <rect class="cls-3" x="11.26" y="21" width="21" height="3.16"/>
    </svg>
  </div>
</template>

<style scoped>

  svg.arrow {
    position: relative;
    width: 3rem;
    height: 4rem;
  }

  .cls-5{fill:#33a3b1;}
  .cls-3{fill:#cce8ec;}
</style>

<script>
export default {
  props: {
    direction: {
      type: String,
      default: 'right'
    }
  },
  computed: {
    style: function() {
      var style = '';
      if(this.direction == 'left'){
        style = style + 'transform: scaleX(-1);';
      }
      if(this.direction == 'right'){
        style = style + 'transform: scaleX(1);';
      }
      return style;
    }
  }
}
</script>
